var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEasyHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 36,
    viewBox: "0 0 78 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0918 20.0081C39.4078 20.0081 39.6647 20.25 39.6647 20.5289V26.7958C39.6647 27.0933 39.4078 27.3349 39.0918 27.3349H38.539V20.0081H39.0918Z",
    fill: "url(#paint0_linear_159_3786)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0918 8.66499C39.4078 8.66499 39.6647 8.90652 39.6647 9.20405V15.471C39.6646 15.7684 39.4077 16.01 39.0918 16.01H38.539V8.66499H39.0918Z",
    fill: "url(#paint1_linear_159_3786)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7317 0.00418738C61.7773 0.00234766 68.0778 -0.245402 71.4746 3.37333C72.0554 3.99138 72.3406 4.68174 72.4635 5.31603C72.7125 6.59956 72.3987 7.7744 71.8242 8.91108C71.0771 10.3896 69.9584 11.5193 68.556 12.3792L67.3769 13.0667L65.1185 14.3063V29.3232C64.0454 29.6412 62.9089 29.8127 61.7317 29.8128C61.351 29.8128 60.9741 29.7944 60.6022 29.7594V16.7854L58.3691 18.012C56.8549 18.8431 55.4993 19.9342 54.3665 21.2353L53.2636 22.5016V19.2587C53.2636 16.7484 54.6344 14.4373 56.8405 13.2255L68.9511 6.57775C66.8612 5.26357 64.3855 4.50293 61.7311 4.50288C54.2487 4.50288 48.1824 10.5464 48.1823 18.0009C48.1823 25.4556 54.2486 31.4996 61.7311 31.4996C65.7768 31.4995 69.408 29.7321 71.8906 26.9313C71.4622 26.7394 71.08 26.5734 70.5475 26.454L77.3444 24.079C76.7896 27.6564 75.5041 31.3057 75.5026 31.3102C75.5011 31.3017 75.4136 30.7968 75.0976 30.109C71.7933 33.7279 67.0288 35.9995 61.7317 35.9996H10C4.47716 35.9996 0 31.5225 0 25.9996V10.0042C0 4.48134 4.47715 0.00418829 10 0.00418738H61.7317ZM11.4609 4.66629V16.01H10.3353V4.66629C7.20471 4.66629 4.66671 7.20435 4.66666 10.3349V25.665C4.66679 28.7955 7.20476 31.3329 10.3353 31.3329V20.0081H11.4609V31.3329H17.1295V4.66629H11.4609ZM18.7689 4.66629V27.3349C18.7689 29.5477 20.5461 31.3328 22.7383 31.3329H27.2617C29.4539 31.3328 31.2311 29.5477 31.2311 27.3349V4.66629H25.5631V26.7958C25.5631 27.0933 25.3062 27.3348 24.9902 27.3349C24.694 27.3349 24.4369 27.0933 24.4368 26.7958V4.66629H18.7689ZM32.8704 4.66629V31.3329H41.3633C43.5556 31.3329 45.3333 29.5478 45.3333 27.3349V21.9983C45.3333 19.9342 43.7728 18.2417 41.778 18.0185V17.9814C43.7728 17.7768 45.3333 16.0843 45.3333 14.0016V8.66499C45.3333 6.45207 43.5556 4.66629 41.3633 4.66629H32.8704Z",
    fill: "url(#paint2_linear_159_3786)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_159_3786",
    x1: 0,
    y1: 17.9998,
    x2: 77.3444,
    y2: 17.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35258B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D36CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_159_3786",
    x1: 0,
    y1: 17.9998,
    x2: 77.3444,
    y2: 17.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35258B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D36CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_159_3786",
    x1: 0,
    y1: 17.9998,
    x2: 77.3444,
    y2: 17.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35258B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D36CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEasyHub);
export default __webpack_public_path__ + "static/media/logoEasyHUB.707c2a8d5d7b62ce7f4c9f8ba084f55a.svg";
export { ForwardRef as ReactComponent };